import { type PropsWithChildren } from 'react';

/**
 * Chart Layout graph-area component.
 */
export const Graph = ({ children }: PropsWithChildren) => (
  // eslint-disable-next-line react/jsx-no-useless-fragment
  (<>{children}</>)
);

Graph['displayName'] = 'ChartLayout.Graph';
